// extracted by mini-css-extract-plugin
export default {"container":"Logotype_container__oj72p","image":"Logotype_image__WPP1Q","label":"Logotype_label__0eNZm","colorPrimary":"Logotype_colorPrimary__CLuvf"};